/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Tree item states.
 */
export const DTreeItemState = {
	/**
	 * A node has children.
	 */
	HAS_CHILDREN: "HAS_CHILDREN",

	/**
	 * A node is opened.
	 */
	OPENED: "OPENED"
};
